import instance from "../axios";

const discounts = {
  state: () => ({}),

  actions: {
    async validateCoupon({ commit }, payload) {
      try {
        const res = await instance.post("/coupons/validate", {
          code: payload.code,
          totalAmount: payload.totalAmount,
        });
        return res.data;
      } catch (error) {
        throw error;
      }
    },
    async getCoupons({ commit }) {
      try {
        const res = await instance.get("/coupons");
        return res.data;
      } catch (error) {
        throw error;
      }
    },
    async createCoupon({ commit }, payload) {
      try {
        const res = await instance.post("/coupons/create", payload);
        return res.data;
      } catch (error) {
        throw error;
      }
    },
    async updateCoupon({ commit }, payload) {
      try {
        const { id, ...data } = payload;
        const res = await instance.put(`/coupons/${id}`, data);
        return res.data;
      } catch (error) {
        throw error;
      }
    },
    async deleteCoupon({ commit }, id) {
      try {
        const res = await instance.delete(`/coupons/${id}`);
        return res.data;
      } catch (error) {
        throw error;
      }
    },
  },

};

export default discounts;
